import { ArrowBack, MailOutline } from "@mui/icons-material";
import { Box, Button, Container, Link, Paper, Typography } from "@mui/material";
import React from "react";
import ReactMarkdown from "react-markdown";
import { Link as RouterLink } from "react-router-dom";
import remarkGfm from "remark-gfm";
import privacyPolicyContent from "../../assets/content/privacy-policy.md?raw";

export const PrivacyPolicy: React.FC = () => {
	return (
		<Box
			sx={{
				minHeight: "100vh",
				bgcolor: "grey.50",
				py: { xs: 3, sm: 6 },
			}}
		>
			<Container component="main" maxWidth="md">
				{/* Header */}
				<Box sx={{ mb: 6 }}>
					<Link
						component={RouterLink}
						to="/login"
						sx={{
							display: "inline-flex",
							alignItems: "center",
							color: "primary.main",
							textDecoration: "none",
							fontSize: "0.875rem",
							fontWeight: 500,
							mb: 3,
							"&:hover": {
								textDecoration: "underline",
							},
						}}
					>
						<ArrowBack sx={{ fontSize: 16, mr: 1 }} />
						Back to Sign In
					</Link>

					<Typography
						variant="body1"
						sx={{
							color: "grey.600",
							fontSize: "1rem",
						}}
					>
						Last updated: {new Date().toLocaleDateString()}
					</Typography>
				</Box>

				{/* Markdown Content */}
				<Box
					data-component="privacy-policy-content"
					sx={{
						bgcolor: "common.white",
						borderRadius: 2,
						p: { xs: 3, sm: 4, md: 6 },
						boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
						// Styling for markdown elements
						"& h1": {
							fontWeight: 600,
							color: "grey.900",
							fontSize: { xs: "2rem", sm: "2.5rem" },
							mb: 4,
							mt: 0,
						},
						"& h2": {
							fontWeight: 600,
							color: "grey.900",
							fontSize: "1.5rem",
							mt: 5,
							mb: 2,
							"&:first-of-type": {
								mt: 3,
							},
						},
						"& p": {
							fontSize: "1rem",
							lineHeight: 1.7,
							color: "grey.700",
							mb: 3,
						},
						"& ul": {
							pl: 3,
							color: "grey.700",
							mb: 3,
						},
						"& li": {
							mb: 1,
							fontSize: "1rem",
							lineHeight: 1.7,
						},
						"& hr": {
							border: "none",
							borderTop: "1px solid",
							borderColor: "divider",
							my: 4,
						},
					}}
				>
					<ReactMarkdown remarkPlugins={[remarkGfm]}>
						{privacyPolicyContent}
					</ReactMarkdown>
				</Box>

				{/* Data Deletion Request Box */}
				<Paper
					data-component="data-deletion-request"
					elevation={0}
					sx={{
						mt: 4,
						p: { xs: 3, sm: 4 },
						borderRadius: 2,
						border: "2px solid",
						borderColor: "primary.main",
						bgcolor: "primary.50",
						textAlign: "center",
					}}
				>
					<Typography
						variant="h6"
						sx={{ fontWeight: 600, color: "grey.900", mb: 1 }}
					>
						Request Data Deletion
					</Typography>
					<Typography variant="body2" sx={{ color: "grey.600", mb: 3 }}>
						If your data appears in our recruitment database and you want it
						removed, send us a request and we will delete it within 30 days.
					</Typography>
					<Button
						data-component="data-deletion-mailto"
						variant="contained"
						startIcon={<MailOutline />}
						href="mailto:admin@artemisrec.com?subject=Data%20Deletion%20Request"
						sx={{ textTransform: "none", fontWeight: 500 }}
					>
						admin@artemisrec.com
					</Button>
				</Paper>
			</Container>
		</Box>
	);
};
